<template>
  <Breadcrumb></Breadcrumb>
  <PageHeader
    title="Holiday Schedule"
    backgroundColor="red"
    textColor="white"
    diagonal="dark"
    size="sm"
    align="start"
  >
  </PageHeader>
  <div class="container my-5">
    <h2 class="table-header">2026 Holidays</h2>
    <table class="table">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Date</th>
          <th scope="col">Day</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">New Year’s Day</th>
          <td>January 1, 2026</td>
          <td>Thursday</td>
        </tr>
        <tr>
          <th scope="row">Martin Luther King, Jr. Day</th>
          <td>January 19, 2026</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Memorial Day</th>
          <td>May 25, 2026</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Juneteenth National Independence Day</th>
          <td>June 19, 2026</td>
          <td>Friday</td>
        </tr>
        <tr>
          <th scope="row">Independence Day</th>
          <td>July 3, 2026</td>
          <td>Friday</td>
        </tr>
        <tr>
          <th scope="row">Labor Day</th>
          <td>September 7, 2026</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Thanksgiving</th>
          <td>November 26&ndash;27, 2026</td>
          <td>Thursday&ndash;Friday</td>
        </tr>
        <tr>
          <th scope="row">Christmas Holidays</th>
          <td>December 25&ndash;31, 2026</td>
          <td>Friday&ndash;Thursday</td>
        </tr>
      </tbody>
    </table>
    <h2 class="table-header">2027 Holidays</h2>
    <table class="table">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Date</th>
          <th scope="col">Day</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">New Year’s Day</th>
          <td>January 1, 2027</td>
          <td>Friday</td>
        </tr>
        <tr>
          <th scope="row">Martin Luther King, Jr. Day</th>
          <td>January 18, 2027</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Memorial Day</th>
          <td>May 31, 2027</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Juneteenth National Independence Day</th>
          <td>June 18, 2027</td>
          <td>Friday</td>
        </tr>
        <tr>
          <th scope="row">Independence Day</th>
          <td>July 5, 2027</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Labor Day</th>
          <td>September 6, 2027</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Thanksgiving</th>
          <td>November 25&ndash;26, 2027</td>
          <td>Thursday&ndash;Friday</td>
        </tr>
        <tr>
          <th scope="row">Christmas Holidays</th>
          <td>December 27&ndash;31, 2027</td>
          <td>Monday&ndash;Friday</td>
        </tr>
      </tbody>
    </table>
    <h2 class="table-header">2028 Holidays</h2>
    <table class="table">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Date</th>
          <th scope="col">Day</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">New Year’s Day</th>
          <td>January 3, 2028</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Martin Luther King, Jr. Day</th>
          <td>January 17, 2028</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Memorial Day</th>
          <td>May 29, 2028</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Juneteenth National Independence Day</th>
          <td>June 19, 2028</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Independence Day</th>
          <td>July 4, 2028</td>
          <td>Tuesday</td>
        </tr>
        <tr>
          <th scope="row">Labor Day</th>
          <td>September 4, 2028</td>
          <td>Monday</td>
        </tr>
        <tr>
          <th scope="row">Thanksgiving</th>
          <td>November 23&ndash;24, 2028</td>
          <td>Thursday&ndash;Friday</td>
        </tr>
        <tr>
          <th scope="row">Christmas Holidays</th>
          <td>December 25&ndash;29, 2028</td>
          <td>Monday&ndash;Friday</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeader from "@/components/PageHeader.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";

export default {
  name: "Holiday Schedule",
  metaInfo: {
    title: "UGA Holiday Schedule",
    description: "",
    og: {
      image: "",
      title: "",
      description: "",
    },
  },
  data() {
    return {};
  },
  components: {
    PageHeader,
    Breadcrumb,
  },
};
</script>

<style lang="scss" scoped>
.table {
  &-header {
    @include heading-base;
    font-size: $header-lg;
    color: $red;
    margin-bottom: 2rem;
    &:not(:first-of-type) {
      margin-top: 3rem;
    }
  }
}
</style>
